export default "__VITE_ASSET__644227d5__"